export enum UserType {
  None,
  Employee,
  Contractor,
}
